import { aboutButtons, aboutMariaText } from "i18n/about";
import {
  ClientandPartnerButton,
  ClientDirectoryDataPartner,
  OurPartnersText,
  readyToGrowCommunity,
} from "i18n/client";
import { ArrowUpRight, Handshake, ThumbsUp } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CTAButton from "Util/CTAButton";

const SecondMainClient = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = OurPartnersText[lang];
  const btn = ClientandPartnerButton[lang];
  const directory = ClientDirectoryDataPartner[lang];
  const navigate = useNavigate();

  return (
    <section className="bg-[#f5f5f3] py-16 md:py-24">
      <div className="max-w-7xl mx-auto text-[#111] px-6">
        {/* Title */}
        <div className="text-center mb-14">
          <div className="text-center my-14">
            {/* <p className="uppercase tracking-[0.3em] text-xs text-[#9B6B53] mb-3">
              {lang === "vi" ? "Các đối tác" : "OUR PARTNERS"}
            </p> */}

            <h2 className="font-[Crimson] text-4xl md:text-5xl text-reddark">
              {t.title}
            </h2>
            <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />
          </div>
        </div>

        {/* Intro */}
        <div className="space-y-8 text-base md:text-lg leading-relaxed mb-8">
          {t.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="space-y-6 mb-8">
          {t.body.map(({ title, description }, i) => (
            <div key={i} className="flex items-start gap-3">
              <ThumbsUp className="w-5 h-5 text-reddark mt-1 shrink-0" />

              <p className="text-base md:text-lg leading-relaxed text-gray-700">
                <span className="font-semibold text-reddark">{title}:</span>{" "}
                {description}
              </p>
            </div>
          ))}
        </div>
        <p className="text-gray-700 text-base md:text-lg leading-relaxed  mb-8">
          {t.closingText}
        </p>
        <div className="mt-3 border-t border-border pt-3">
          <h3 className="font-[Crimson] text-xl md:text-2xl text-reddark mb-8">
            {t.closingTitle}
          </h3>
        </div>
      </div>
      {/* Gipd company */}
      {/* <div className="max-w-7xl mx-auto px-6 mb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {directory.clients.map((client, index) => (
            <a
              key={index}
              href={client.link}
              target="_blank"
              rel="noopener noreferrer"
              className="
    group
    relative
    overflow-hidden
    rounded-2xl
    border border-[#E8DED5]
    bg-white
    transition-all duration-300
    hover:-translate-y-1
    hover:shadow-lg
  "
            >
              <div
                className="
      absolute top-0 left-0
      h-1 w-full
      scale-x-0
      origin-left
      transition-transform duration-500
      group-hover:scale-x-100
    "
                style={{ background: client.color }}
              />

              <div className="p-5">
                <div className="flex items-start gap-4 mb-4">
                  <div
                    className="
          w-14 h-14
          rounded-2xl
          flex items-center justify-center
          shrink-0
          font-bold text-xl
        "
                    style={{
                      background: `${client.color}15`,
                      color: client.color,
                    }}
                  >
                    {client.name.charAt(0)}
                  </div>

                  <div className="min-w-0 flex-1">
                    <span
                      className="
            inline-flex
            px-2.5 py-1
            rounded-full
            text-[10px]
            font-semibold
            uppercase
            text-white
            mb-2
          "
                      style={{ background: client.color }}
                    >
                      {client.badge}
                    </span>

                    <h3
                      className="font-[Crimson] text-xl font-semibold"
                      style={{ color: client.color }}
                    >
                      {client.name}
                    </h3>
                  </div>

                  <ArrowUpRight
                    size={18}
                    className="
          text-gray-400
          group-hover:text-reddark
          transition
          shrink-0
        "
                  />
                </div>

                <p className="text-sm text-gray-600 leading-relaxed">
                  {client.description}
                </p>

                <div className="mt-4 pt-4 border-t border-[#E8DED5]">
                  <span
                    className="
          text-[11px]
          uppercase
          tracking-[0.15em]
          font-semibold
        "
                    style={{ color: client.color }}
                  >
                    {lang === "vi" ? "Xem đối tác" : "Visit Partner"}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div> */}
      <div className="max-w-7xl mx-auto px-6 mb-20">
        <div
          className="
      relative overflow-hidden
      rounded-[32px]
      border border-[#E8DED5]
      bg-gradient-to-r
      from-white
      via-[#FCFAF8]
      to-[#F7F2EE]
      shadow-[0_15px_40px_rgba(0,0,0,0.05)]
    "
        >
          {/* Decorative Accent */}
          <div className="absolute left-0 top-0 h-full w-2 bg-reddark" />

          <div className="absolute -right-16 -top-16 w-64 h-64 bg-reddark/5 rounded-full blur-3xl" />

          <div
            className="
        relative z-10
        px-6 md:px-10 lg:px-14
        py-8 md:py-10
        flex flex-col lg:flex-row
        lg:items-center
        lg:justify-between
        gap-8
      "
          >
            {/* Content */}
            <div className="max-w-3xl">
              <p className="text-xs uppercase tracking-[0.3em] text-[#9B6B53] mb-3">
                {lang === "vi" ? "Cơ hội hợp tác" : "Partnership Opportunity"}
              </p>

              <h3 className="font-[Crimson] text-3xl md:text-4xl text-[#111] leading-tight">
                {lang === "vi"
                  ? "Cùng tạo giá trị và phát triển bền vững"
                  : "Let's Create Value Together"}
              </h3>

              <p className="text-gray-600 mt-4 text-base md:text-md leading-relaxed">
                {lang === "vi"
                  ? "Maria Advisory luôn chào đón các doanh nghiệp, chuyên gia, hiệp hội và tổ chức cộng đồng cùng đồng hành để tạo ra nhiều cơ hội phát triển cho khách hàng và cộng đồng."
                  : "Maria Advisory welcomes businesses, professionals, associations, and community organisations to collaborate in creating greater opportunities for clients and communities."}
              </p>
            </div>

            {/* CTA */}
            <CTAButton
              variant="primary"
              icon={Handshake}
              onClick={() => navigate("/contact")}
              text={lang === "vi" ? "Liên hệ hợp tác" : "Partner With Us"}
            />
            {/* <button
              className="
          shrink-0
          group
          px-8 py-4
          rounded-2xl
          bg-reddark
          text-white
          font-semibold
          flex items-center justify-center gap-3
          shadow-lg shadow-reddark/20
          hover:shadow-xl hover:shadow-reddark/30
          hover:-translate-y-1
          transition-all duration-300
        "
            >
              {lang === "vi" ? "Liên hệ hợp tác" : "Partner With Us"}

              <ArrowUpRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecondMainClient;
